module.exports = __webpack_public_path__ + "static/media/spring.c4c0afce.svg";